import React from 'react'
import { Image, Link, CtaArrow } from 'newComponents'
import './styles.scss'

const processData = ({ featuredCaseStudies, caseStudies }) => {
  const returnData = []

  featuredCaseStudies.items.map((featured, index) => {
    const {
      featured_case_study: { uid }
    } = featured
    returnData[index] = {
      featureImage: featured.featured_case_study_image.url
    }
    caseStudies.edges.map((studies) => {
      let quote
      let author
      let avatar
      let role
      const { node: study } = studies
      const {
        uid: studyUid,
        url,
        data: {
          company_name: companyName,
          headline: { text: headlineText },
          logo: { url: logoUrl },
          body: slices
        }
      } = study

      slices.map((slice) => {
        if (slice.slice_type === 'customer_quote') {
          const { primary: quoteInfo } = slice
          quote = quoteInfo.quote.text
          author = quoteInfo.author.text
          avatar = quoteInfo.avatar.url
          role = quoteInfo.role.text
        }
      })

      if (uid === studyUid) {
        returnData[index].companyName = companyName
        returnData[index].headlineText = headlineText
        returnData[index].logoUrl = logoUrl
        returnData[index].quote = quote
        returnData[index].author = author
        returnData[index].avatar = avatar
        returnData[index].role = role
        returnData[index].url = url
      }
    })
  })
  return returnData
}

const FeaturedCaseStudies = ({ content }) => {
  const featuredStudies = processData(content)

  return (
    <div className="container featured-case-studies">
      {featuredStudies.map((featuredStudy) => {
        const { url, featureImage, companyName, logoUrl, quote, author, avatar, role, headlineText } = featuredStudy

        return (
          <div key={url} className="featured-case-study">
            <div className="featured-case-study-column featured-case-study-left-column">
              <Image image={featureImage} />
            </div>
            <div className="featured-case-study-column featured-case-study-right-column">
              {logoUrl && <Image className="featured-case-study-column-logo" image={logoUrl} />}
              <h3>{headlineText}</h3>
              <p className="featured-case-study-column-quote">"{quote}"</p>
              <div className="featured-case-study-column-author-group">
                {avatar && <Image className="featured-case-study-column-avatar" image={avatar} />}
                <div className="featured-case-study-column-author-group-texts">
                  <p className="featured-case-study-column-author">{author}</p>
                  <p className="featured-case-study-column-role">{role}</p>
                </div>
              </div>
              <Link to={`/case-studies${url}`}>
                {companyName} Case Study <CtaArrow />
              </Link>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default FeaturedCaseStudies
